var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 6.5,
    stroke: "#D6D5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.0199C16.59 16.0199 16.25 15.6799 16.25 15.2699V11.9399C16.25 11.5299 16.59 11.1899 17 11.1899C17.41 11.1899 17.75 11.5299 17.75 11.9399V15.2699C17.75 15.6899 17.41 16.0199 17 16.0199Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0199 25.85C14.4399 25.85 11.8699 25.44 9.41987 24.62C8.50987 24.32 7.81987 23.67 7.51987 22.85C7.21987 22.03 7.31987 21.09 7.80987 20.27L9.07987 18.15C9.35987 17.68 9.60987 16.8 9.60987 16.25V14.15C9.60987 10.06 12.9299 6.73999 17.0199 6.73999C21.1099 6.73999 24.4299 10.06 24.4299 14.15V16.25C24.4299 16.79 24.6799 17.68 24.9599 18.15L26.2299 20.27C26.6999 21.05 26.7799 21.98 26.4699 22.83C26.1599 23.68 25.4799 24.33 24.6199 24.62C22.1699 25.45 19.5999 25.85 17.0199 25.85ZM17.0199 8.24999C13.7599 8.24999 11.1099 10.9 11.1099 14.16V16.26C11.1099 17.07 10.7899 18.24 10.3699 18.93L9.09987 21.06C8.83987 21.49 8.77987 21.95 8.92987 22.35C9.07987 22.75 9.41987 23.05 9.89987 23.21C14.4999 24.74 19.5599 24.74 24.1599 23.21C24.5899 23.07 24.9199 22.75 25.0699 22.33C25.2299 21.91 25.1799 21.45 24.9499 21.06L23.6799 18.94C23.2599 18.25 22.9399 17.08 22.9399 16.27V14.17C22.9299 10.9 20.2799 8.24999 17.0199 8.24999Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 28.3999C15.9299 28.3999 14.8799 27.9599 14.1199 27.1999C13.3599 26.4399 12.9199 25.3899 12.9199 24.3199H14.4199C14.4199 24.9999 14.6999 25.6599 15.1799 26.1399C15.6599 26.6199 16.3199 26.8999 16.9999 26.8999C18.4199 26.8999 19.5799 25.7399 19.5799 24.3199H21.0799C21.0799 26.5699 19.2499 28.3999 16.9999 28.3999Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInactive);
export default __webpack_public_path__ + "static/media/notification-inactive.9a1f2032468ce242d92fd92e823c8bd0.svg";
export { ForwardRef as ReactComponent };